import { API_STATUS } from 'core-lib/constants/network';
import InfiniteScroll from 'react-infinite-scroller';
import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import useStoreHome from 'src/modules/parkplusStoreV2/hooks/useStoreHome';
import Layouts from 'src/modules/parkplusStoreV2/uiComponents/Layouts';
import { Loader } from 'ui-v2/components/Loader';

export const PaginateLayouts = () => {
  const { fetchHomePage } = useStoreHome();
  const { storeHomepage, storeHomepageData, storeHomepageApiStatus } = useParkplusStoreV2();

  const loadMoreLayouts = async () => {
    if (
      storeHomepage.hasMore &&
      ![API_STATUS.default, API_STATUS.in_progress].includes(storeHomepageApiStatus)
    ) {
      await fetchHomePage('STORE_HOMEPAGE', storeHomepage.page);
    }
  };

  return (
    <InfiniteScroll
      loadMore={loadMoreLayouts}
      hasMore={storeHomepage.hasMore}
      loader={
        <div style={{ margin: '24px 0', display: 'grid', placeItems: 'center' }}>
          <Loader width={36} />
        </div>
      }
      threshold={500}
    >
      <Layouts data={storeHomepageData} />
    </InfiniteScroll>
  );
};
